import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Pencil, Save, X as XIcon } from "lucide-react";
import { API } from "../../lib/auth";

const EMPTY = { current: "", next: "", confirm: "" };
const inputCls = "w-full bg-[#0E2452] border border-[#2F568F] text-white px-3 py-2 rounded-xl focus:outline-none focus:border-[#FF5A00]";
const labelCls = "text-[10px] uppercase tracking-widest text-white/40 font-display block mb-1";

export const PasswordSection = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const close = () => { setOpen(false); setForm(EMPTY); };

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 6) { toast.error("A nova palavra-passe deve ter pelo menos 6 caracteres"); return; }
    if (form.next !== form.confirm) { toast.error("A confirmação não coincide"); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: form.current, new_password: form.next }, { withCredentials: true });
      toast.success("Palavra-passe alterada");
      close();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível alterar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid="password-section" className="rounded-2xl border border-[#2F568F] bg-[#0B1D44] p-5 md:p-6 mb-6">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div>
          <div className="section-label mb-1">// Segurança</div>
          <h2 className="font-display font-bold uppercase text-white text-lg">Palavra-passe</h2>
        </div>
        {!open && (
          <button data-testid="open-change-password-btn" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 border border-[#2F568F] hover:border-[#FF5A00] text-white/80 hover:text-white font-body text-sm px-3 py-2 rounded-full transition-all">
            <Pencil className="w-3.5 h-3.5" /> Alterar
          </button>
        )}
      </div>

      {!open ? (
        <p className="text-white/50 font-body text-sm">Altere a palavra-passe da sua conta em qualquer momento.</p>
      ) : (
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className={labelCls}>Palavra-passe atual</label>
            <input data-testid="current-password-input" type="password" value={form.current} onChange={set("current")} autoComplete="current-password" className={inputCls} required />
          </div>
          <div>
            <label className={labelCls}>Nova palavra-passe</label>
            <input data-testid="new-password-input" type="password" value={form.next} onChange={set("next")} autoComplete="new-password" minLength={6} className={inputCls} required />
            <p className="text-[10px] text-white/40 font-body mt-1">Mínimo 6 caracteres</p>
          </div>
          <div>
            <label className={labelCls}>Confirmar nova</label>
            <input data-testid="confirm-password-input" type="password" value={form.confirm} onChange={set("confirm")} autoComplete="new-password" minLength={6} className={inputCls} required />
          </div>
          <div className="md:col-span-2 flex gap-2 justify-end">
            <button type="button" data-testid="cancel-password-btn" onClick={close} disabled={saving} className="inline-flex items-center gap-2 border border-[#2F568F] text-white/80 hover:text-white font-body text-sm px-3 py-2 rounded-full transition-all disabled:opacity-50">
              <XIcon className="w-3.5 h-3.5" /> Cancelar
            </button>
            <button type="submit" data-testid="save-password-btn" disabled={saving} className="inline-flex items-center gap-2 bg-[#FF5A00] hover:bg-[#E65100] text-white font-display font-bold uppercase text-[11px] tracking-wider px-3 py-2 rounded-full transition-all disabled:opacity-50">
              <Save className="w-3.5 h-3.5" /> {saving ? "A guardar..." : "Guardar nova palavra-passe"}
            </button>
          </div>
        </form>
      )}
    </section>
  );
};

export default PasswordSection;
